import React from 'react'
import { Add, InfoOutlined, ModeEditOutlineTwoTone } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";

import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import AppTableDateTime from "components/Shared/AppTableDateTime";
import CustomTabs from "components/Shared/CustomTabs";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useLazyListComplianceQuery } from "store/services/complianceApi";

import { useAppMeta, useTablePagination } from "hooks";

const ComplianceListScreen = () => {

  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [{ title: "Compliance" }];

  const complianceTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const columns = [
    {
      name: "Customs ID",
      selector: (row) => row?.customsId,
      cell: (row) => row?.customsId
    },
    {
      name: "Shipment ID",
      selector: (row) => row?.shipment?.shipmentId,
      cell: (row) => row?.shipment?.shipmentId,
    },
    {
      name: "CustomsOfficer ID",
      selector: (row) => row?.customsOfficerId,
      cell: (row) => row?.customsOfficerId,
    },
    {
      name: "Clearance Date",
      selector: (row) => <AppTableDateTime date={row?.clearanceDate} />,
    },
    {
      name: "Customs Status",
      selector: (row) => row?.customsStatus,
      cell: (row) => row?.customsStatus,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/app/crm/compliance/${row?._id}/detail`}>
            <IconButton size="small" aria-label="View Compliance" color="primary">
              <InfoOutlined />
            </IconButton>
          </Link>
          <Link
            to={`/app/crm/compliance/${row?._id}/edit`}>
            <IconButton size="small" aria-label="Edit Compliance">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      right: true,
    },

  ];


  // RTK Query
  const [fetchCompliance, { data: complianceRes, isLoading, isFetching, error }] =
    useLazyListComplianceQuery();

  React.useEffect(() => {
    fetchCompliance({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword })
    });
  }, [activeTab, currentPage, fetchCompliance, keyword, perPage])

  useAppMeta(`${activeTab} Compliance`);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CustomTabs tabs={complianceTabs} activeTab={activeTab} />

        <TableFilter
          searchLabel="Customs ID"
          disabled={isLoading || isFetching}
        >
          <div className="font-medium"> {activeTab} Compliance </div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={complianceRes?.data ?? []}
          progressPending={isLoading || isFetching}
          paginationPerPage={perPage}
          paginationTotalRows={complianceRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default ComplianceListScreen;

const PageActions = () => {
  return (
    <>
      <Link to="/app/crm/compliance/create">
        <Button startIcon={<Add />} variant="contained" color="primary">
          Add Compliance
        </Button>
      </Link>
    </>
  );
}